import { throwError as observableThrowError, Observable } from 'rxjs';

import { finalize, catchError, map } from 'rxjs/operators';
import { AjaxLoadIndicator } from './models/ajax-load-indicator';
import { Injectable } from '@angular/core';
import { SmartHttpService } from './smart-http.service';
import { LoadIndicatorService } from './load-indicator.service';
import { AjaxLoadOptions } from './models/ajax-load-options';
import { ApplicationErrorInfo } from './models/application-error-info';
import { AjaxErrorInfo } from './models/ajax-error-info';
import { NewPagingWrapper } from './models/paging-wrapper';
//import { Serializable } from './models/Serializable';
import { ApiErrorHandler } from './models/api-error-handler';
import { DefaultApiErrorHandlerService } from './default-api-error-handler.service';
import { NewSmartHttpService } from './new-smart-http.service';
import { ApiResponse } from './api-response';

@Injectable({ providedIn: 'root' })
export class NewAjaxDataServiceService {
  public getData<T>(
    url: string,
    params?: { [index: string]: any },
    loadOptions?: AjaxLoadOptions
  ): Observable<T> {
    loadOptions = this.initLoadOptions(loadOptions);

    if (loadOptions.loadIndicatorInfo) {
      this.loadIndicator.loadStart(
        loadOptions.loadIndicatorInfo.targetId || null
      );
    }
    return this.newSmartHttp.get(url, params).pipe(
      catchError((err) =>
        this.processAjaxError(<AjaxErrorInfo>err, loadOptions.errorHandler)
      ),
      map((d) => this.checkApplicationError(d)),
      //map(d => this.extractData(d.data, type)),
      catchError((err) =>
        this.processApplicationError(err, loadOptions.errorHandler)
      ),
      finalize(() => {
        if (loadOptions.loadIndicatorInfo) {
          this.loadIndicator.loadComplete(
            loadOptions.loadIndicatorInfo.targetId || null
          );
        }
      })
    );
  }

  public getDataPaging<T>(
    url: string,
    params: { [index: string]: any },
    loadOptions?: AjaxLoadOptions
  ): Observable<ApiResponse<NewPagingWrapper<T>>> {
    loadOptions = this.initLoadOptions(loadOptions);

    if (loadOptions.loadIndicatorInfo) {
      this.loadIndicator.loadStart(
        loadOptions.loadIndicatorInfo.targetId || null
      );
    }
    return this.newSmartHttp.get(url, params).pipe(
      catchError((err) => this.processAjaxError(err, loadOptions.errorHandler)),
      map((d) => this.checkApplicationError(d)),
      // map(d => this.extractDataMulti(d.data, d.totalCount, type)),
      catchError((err) =>
        this.processApplicationError(err, loadOptions.errorHandler)
      ),
      finalize(() => {
        if (loadOptions.loadIndicatorInfo) {
          this.loadIndicator.loadComplete(
            loadOptions.loadIndicatorInfo.targetId || null
          );
        }
      })
    );
  }

  public postData<T>(
    url: string,
    payLoad: any,
    loadOptions?: AjaxLoadOptions
  ): Observable<ApiResponse<T>> {
    loadOptions = this.initLoadOptions(loadOptions);

    if (loadOptions.loadIndicatorInfo) {
      this.loadIndicator.loadStart(
        loadOptions.loadIndicatorInfo.targetId || null
      );
    }

    return this.newSmartHttp.post<T>(url, payLoad).pipe(
      catchError((err) => this.processAjaxError(err, loadOptions.errorHandler)),
      map((d) => this.checkApplicationError(d)),
      //map(d => this.extractData(d.data, type)),
      catchError((err) =>
        this.processApplicationError(err, loadOptions.errorHandler)
      ),
      finalize(() => {
        if (loadOptions.loadIndicatorInfo) {
          this.loadIndicator.loadComplete(
            loadOptions.loadIndicatorInfo.targetId || null
          );
        }
      })
    );
  }

  public postDataPaging<T>(
    url: string,
    payLoad: any,
    loadOptions?: AjaxLoadOptions
  ): Observable<ApiResponse<NewPagingWrapper<T>>> {
    loadOptions = this.initLoadOptions(loadOptions);

    if (loadOptions.loadIndicatorInfo) {
      this.loadIndicator.loadStart(
        loadOptions.loadIndicatorInfo.targetId || null
      );
    }

    return this.newSmartHttp.post<NewPagingWrapper<T>>(url, payLoad).pipe(
      catchError((err) => this.processAjaxError(err, loadOptions.errorHandler)),
      map((d) => this.checkApplicationError(d)),
      // map(d => this.extractDataMulti(d.data, d.totalCount, type)),
      catchError((err) =>
        this.processApplicationError(err, loadOptions.errorHandler)
      ),
      finalize(() => {
        if (loadOptions.loadIndicatorInfo) {
          this.loadIndicator.loadComplete(
            loadOptions.loadIndicatorInfo.targetId || null
          );
        }
      })
    );
  }

  constructor(
    private smartHttp: SmartHttpService,
    private loadIndicator: LoadIndicatorService,
    private defaultErrorHandler: DefaultApiErrorHandlerService,
    private newSmartHttp: NewSmartHttpService
  ) {}

  private checkApplicationError(rawData: {
    success: boolean;
    data: any;
    totalCount?: number;
  }) {
    if (rawData.success) {
      return <any>rawData;
    }

    return observableThrowError(rawData.data);
  }

  private processApplicationError(
    error: ApplicationErrorInfo,
    errorHandler: ApiErrorHandler
  ) {
    if (errorHandler.applicationErrorHandler != null) {
      errorHandler.applicationErrorHandler.handle(error);
    }
    return observableThrowError(error);
  }

  private processAjaxError(
    error: AjaxErrorInfo,
    errorHandler: ApiErrorHandler
  ) {
    if (errorHandler.ajaxErrorHandler != null) {
      errorHandler.ajaxErrorHandler.handle(error);
    }
    return observableThrowError(error);
  }

  private initLoadOptions(loadOptions: AjaxLoadOptions) {
    let result: AjaxLoadOptions = loadOptions || <AjaxLoadOptions>{};

    result.errorHandler = result.errorHandler || this.defaultErrorHandler;

    if (!result.isBackground) {
      result.loadIndicatorInfo =
        result.loadIndicatorInfo || AjaxLoadIndicator.getDefault();
    }

    return result;
  }

  // private extractData<T extends Serializable<T>>(obj: any, type: { new(): T ;}): T {
  //     let t = new type();
  //     let result = t.fromObject(obj);
  //     return result;
  // }

  // private extractDataMulti<T extends Serializable<T>>(rawData: any, totalCount: number, type: { new (): T; }): PagingWrapper<T> {
  //     let result: PagingWrapper<T> = null;

  //     let items = rawData.map(obj => {
  //         let t = new type();
  //         let result = t.fromObject(obj);
  //         return result;
  //     });

  //     result = new PagingWrapper<T>(rawData, totalCount);

  //     return result;
  // }
}
